import type { FunctionComponent } from 'react';
import { useState } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
} from '~/ui/core/dropdown-menu/DropdownMenu';
import { IconPlus } from '~/ui/core/icons';

import { LearningOpportunitySkillSearchContent } from './LearningOpportunitySkillSearchContent';

export const TrainedSkillsOptions: FunctionComponent<{ readonly languageCode?: string }> = ({ languageCode }) => {
    const translate = useTranslate();
    const [open, setOpen] = useState(false);

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger>
                <Button iconPosition="leading" size="sm" type="button" variant="secondary">
                    <IconPlus size={12} />
                    {translate('common.edit')}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" sideOffset={5}>
                <DropdownMenuSub>
                    <DropdownMenuSubTrigger>
                        {translate('common.add')} {translate('common.skill')}
                    </DropdownMenuSubTrigger>
                    <DropdownMenuSubContent>
                        <LearningOpportunitySkillSearchContent
                            languageCode={languageCode}
                            onSkillAdded={() => setOpen(false)}
                        />
                    </DropdownMenuSubContent>
                </DropdownMenuSub>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
